import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import moment from 'moment';



export async function onInsert(response, entity, data) {


    if (entity === 'customer_offer') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_offer_internal_code', body)
            console.log('onInsert', resp)
        }
    }
    if (entity === 'customer_order') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_order_internal_code', body)
            console.log('onInsert', resp)

        }
    }
    if (entity === 'customer_ddt') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_ddt_internal_code', body)
            console.log('onInsert', resp)
            if (resp.success === 1) {
                var constraints = [
                    { fieldName: "internalCode", type: "value", value: data.orderNumber },
                ]
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var r = await DataManager.searchItems('customer_order', 1, 100, sorting, "", [], constraints);
                if (r.success === 1) {
                    var data = {
                        numberDocument: resp.internalCode
                    }
                    var u = await DataManager.updateItem('customer_order', data, r.body[0].id)
                    console.log(u);
                }
            }
        }
    }
    if (entity === 'customer_invoices') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_invoice_internal_code', body)
            console.log('onInsert', resp)
            if (resp.success === 1) {
                var constraints = [
                    { fieldName: "internalCode", type: "value", value: data.orderNumber },
                ]
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var r = await DataManager.searchItems('customer_order', 1, 100, sorting, "", [], constraints);
                if (r.success === 1) {
                    var data = {
                        numberDocument: resp.internalCode
                    }
                    var u = await DataManager.updateItem('customer_order', data, r.body[0].id)
                    console.log(u);
                }
            }
        }
    }
    if (entity === 'supplier_transport_document') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_supplier_internal_code', body)
            console.log('onInsert', resp)
        }
    }
    if (entity === 'supplier_offer') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_supplier_offer_internal_code', body)
            console.log('onInsert', resp)
        }
    }
    if (entity === 'supplier_order') {
        /* inserisco internalCode progressivo : anno-counter */
        console.log(response, data)
        if (response.success === 1) {
            var body = {
                id: response.id
            }
            var resp = await ApiManager.sendAuthenticatedRequest('/custom/insert_supplier_order_internal_code', body)
            console.log('onInsert', resp)
        }
    }

}